import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { IMember } from "./types"
import { ISession } from "./events/types"

export function useMembers(config?: UseQueryOptions<IMember[]>) {
  return useQuery<IMember[]>(["operation", "administration", "members"], {
    ...config,
  })
}

export function useMember(
  memberId?: string,
  config?: UseQueryOptions<IMember>
) {
  return useQuery<IMember>(
    ["operation", "administration", "members", memberId],
    {
      ...config,
    }
  )
}

export function useExtMemberSessions(
  params?: any,
  config?: UseQueryOptions<ISession[]>
) {
  return useQuery<ISession[]>(
    ["operation", "administration", "members", "external", "sessions", params],
    config
  )
}
